import { isNotNullish, isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { sidebarNodeTypes } from '../../../config/config';
import { IS_SIDEBAR_TYPE_PROP } from './../../common/config/common-prop-names';

let originalLayerName: string | undefined;

export const highlightGroup = (e: go.InputEvent, group: go.GraphObject, doHighlight: boolean) => {
  if (!group?.diagram || !(group instanceof go.Group)) {
    return;
  }
  e.handled = true;

  if (!doHighlight) {
    group.isHighlighted = false;
    group.layerName = originalLayerName || group.layerName;
    return;
  }

  const tool = group.diagram.toolManager.draggingTool;
  const map = tool.draggedParts || tool.copiedParts;

  if (!map) {
    return;
  }

  if (group.canAddMembers(map.toKeySet())) {
    group.isHighlighted = true;
    originalLayerName = group.layerName;
    group.layerName = 'Background';
  }
};

export const finishDrop = (e: go.InputEvent, group: go.Group | null, category: string) => {
  let ok = true;
  if (isNotNullish(group) && isNotNullish(group.diagram) && group.category === category) {
    ok = group.addMembers(group.diagram.selection, true);
  }
  if (isNullish(group) && e.diagram.selection.all((s) => s.containingGroup?.category === category)) {
    ok = e.diagram.commandHandler.addTopLevelParts(e.diagram.selection, true);
  }
  if (!ok) {
    e.diagram.currentTool.doCancel();
  }
};

export const sidebarMemberValidation = (thisGroup: go.Group, part: go.Part): boolean =>
  !part.data[IS_SIDEBAR_TYPE_PROP] ||
  part.category === sidebarNodeTypes.stickyNode ||
  part.category === sidebarNodeTypes.textNode;
